module.exports = __webpack_public_path__ + "img/start_7.0bfdec88.svg";